<div class="d-flex analysis-layout">
  <!-- Left Sidebar Navigation -->
  <app-analysis-nav [analysisType]="analysisType" [config]="navConfig"> </app-analysis-nav>

  <!-- Main Content -->
  <div class="content-area">
    <app-loader [isLoading]="isLoading"></app-loader>

    <h2>Sample Reads and QC</h2>

    @if (projectViewData) {
      <div>
        <div class="table-controls p-3">
          <div class="row p-3">
            <div class="col-2">
              <label>Analysis Type</label>
              <select class="form-select" (change)="onSelectedAnalysis($event)">
                @for (entry of projectViewData | keyvalue; track entry.key) {
                  <option [value]="entry.key" [selected]="entry.key === activeAnalysisKey">
                    {{ entry.value.desc }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="table-controls p-3">
      <div class="table-actions" role="group" aria-label="Export quality control statistics">
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="!activeRows.length"
          (click)="copyStatsTable()"
        >
          Copy
        </button>
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="!activeRows.length"
          (click)="exportStatsExcel()"
        >
          Excel
        </button>
        <button
          class="btn btn-outline-secondary"
          type="button"
          [disabled]="!activeRows.length"
          (click)="exportStatsPdf()"
        >
          PDF
        </button>
      </div>
      @if (exportMessage) {
        <p class="export-message" role="status">{{ exportMessage }}</p>
      }
      <div class="global-filter">
        <label class="visually-hidden" for="flairr-stats-global-filter">Search quality control statistics</label>
        <input
          id="flairr-stats-global-filter"
          class="form-control"
          type="search"
          placeholder="Search all columns"
          [value]="globalFilter"
          (input)="onGlobalFilterChange($event, statsTable)"
        />
      </div>
    </div>
    <div class="table-container">
      <p-table
        #statsTable
        [value]="activeRows"
        [columns]="activeColumns"
        [filters]="statsFilters"
        [globalFilterFields]="globalFilterFields"
        (onFilter)="onStatsTableFilter($event)"
        [paginator]="true"
        [rows]="20"
        [rowsPerPageOptions]="pageSizes"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        class="flairr-stats-table"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (column of columns; track column.data) {
              <th [pSortableColumn]="column.data">
                <div class="table-header-content">
                  <span class="table-header-title">
                    {{ column.title }}
                    <p-sortIcon [field]="column.data"></p-sortIcon>
                  </span>
                  <p-columnFilter
                    [field]="column.data"
                    [type]="isNumericColumn(column) ? 'numeric' : 'text'"
                    display="menu"
                    [showOperator]="true"
                    [showMatchModes]="true"
                    [showAddButton]="true"
                    [filterButtonProps]="filterButtonProps"
                  />
                </div>
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            @for (column of columns; track column.data) {
              <td>{{ rowData[column.data] }}</td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length || 1">No quality control statistics available.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
